import gql from 'graphql-tag'

export default gql`
  query getCompaniesForContact {
    getCompaniesForContact {
      _id
      name
      foldersCount
      lastShared
    }
  }
`
